function loadScript(src) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.src = src;
    script.charset = 'utf-8';
    script.async = 1;
    script.onload = script.onerror = function onload(evt) {
      script.onload = script.onerror = null;
      if (evt) {
        evt.type === 'error' ? reject(evt) : resolve(evt);
      }
    };
    document.head.appendChild(script);
  });
};

export default loadScript;
